import { TStaffPermission } from "../interface"

export const usePermsData=()=>{
    // prepare the data for permission checkbox component
    const modifiedStaffPermission=(staffPermission:string[]):TStaffPermission[]=>{
        return staffPermission?.map((item:string)=> ({
            id: crypto.randomUUID(),
            module_name:'',
            perm_code: item,
            parent_permission_id:null
        }))
    }
    // end
    return{
        modifiedStaffPermission
    }
}